define(["./colorpickerModule"], function () {
});